import React from 'react';

import { withRouter } from 'react-router-dom';

import Button from '../../artzu-ui/src/Button';
import Modal from '../../artzu-ui/src/Modal';

const SendModal = ({ open, closeModal, history, modalMessage }) => (
  <Modal open={open}>
    <div className="report__modal__container">
      <div className="report__modal__container__message report__modal__container__message--bold">{modalMessage}</div>
      <div>
        <Button
          label="Okay"
          onClick={() => {
            history.push('/mybookings');
            closeModal('open');
          }}
        />
      </div>
    </div>
  </Modal>
);

export default withRouter(SendModal);



// WEBPACK FOOTER //
// ./src/components/Report/SendModal.js